import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import StepperInput from './StepperInput';
import styles from './styles.module.scss';
import { Row } from '../../../../../components/Basic/Blocks';
import { Input } from '../../../../../components/Basic/Inputs';

const WarehouseStepperInput = ({ item = {}, order = {}, entryItem = {}, save = () => { }, ...props }) => {
  const skladName = useSelector((store) => store.ui.skladName.short_name);
  const [data, setData] = useState({});

  useEffect(() => {
    //setData(item);
  }, [item]);

  console.log(item)
  return (
    <>
      <Row>
        <Input
          value={entryItem?.product?.quantity}
          fontSize="14px"
          textAlign="center"
          width={'35px'}
          readOnly
          styles={styles.bold_input}
          style={{ marginRight: '15px', fontWeight: 600 }}
        />

        <StepperInput
          item={item}
          order={order}
          save={(v) => {
            setData(v);
            save(v);
          }}
          skladName={skladName}
        />
      </Row>
    </>
  );
};

export default WarehouseStepperInput;
